import React from 'react';

import { deleteNotificationItem, sendPushNotification } from 'backend/IQuestion/Notification';
import {  getUsersList } from 'backend/User';


const NotificationListIQuestion = ({ list, callSuccess }) => {

  const clickOnEditNotification = () => {
    
  };

  const handleDelete = (id) => {
    if (window.confirm("Вы хотите удадить PUSH-нотификацию?")) {
      deleteNotificationItem(id)
        .then(() => callSuccess());
    }
  };

  const handlePush = (lang, notification) => {
    getUsersList()
      .then((result) => {
        sendPushNotification(lang, result, notification)
          .then(() => {
            alert('Success send to all');
          });
      })
      .catch((error) => {
        console.log('Error getUsersList', error);
      });
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <br /><br />
        <table id="simple-table" className="table table-bordered table-hover">
					<thead>
						<tr>
							<th>Название</th>
							<th>Push-текст</th>
							<th>Номер отправки</th>
              <th className="hidden-480">Дата редактирования</th>
							<th></th>
						</tr>
				  </thead>

					<tbody>
            {list.map((value) => {
              const dateUpdated = new Date(value.dateUpdated).toLocaleDateString();
              return (
                <tr key={value.id}>
                  <td>
                    EN: {value.title.en} <hr/>
                    RU: {value.title.ru} <hr/>
                    UK: {value.title.uk} <hr/>
                  </td>
                  <td>
                    EN: {value.content.en} <hr/>
                    RU: {value.content.ru} <hr/>
                    UK: {value.content.uk} <hr/>
                  </td>
                  <td>{value.number}</td>
                  <td>{dateUpdated}</td>
                  <td>
                    <div className="btn-group">
											<button
                        className="btn btn-xs btn-success"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('all', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i>
											</button>
                      <br/><br/>
                      <button
                        className="btn btn-xs btn-info"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('en', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i> EN
											</button>
                      <br/><br/>
                      <button
                        className="btn btn-xs btn-info"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('ru', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i> RU
											</button>
                      <br/><br/>
                      <button
                        className="btn btn-xs btn-info"
                        title="Отправить всем пользователям"
                        onClick={() => handlePush('uk', value)}
                      >
												<i className="ace-icon fa fa-check bigger-120"></i> UK
											</button>

                      <hr/>
                      <br/><br/>
											<button className="btn btn-xs btn-info">
												<i className="ace-icon fa fa-pencil bigger-120"></i>
											</button>

											<button className="btn btn-xs btn-danger" onClick={() => handleDelete(value.id)}>
												<i className="ace-icon fa fa-trash-o bigger-120"></i>
											</button>
										</div>
                  </td>
                </tr>
              );
            })}
					</tbody>
				</table>
      </div>
    </div>
  );
};

export default NotificationListIQuestion;
